module.exports = __webpack_public_path__ + "static/media/sci-logo.82d4c7b4.png";